import {
  Home,
  BarChart3,
  Globe,
  Users,
  FileText,
  Award,
  // Activity,
  // Brain,
  // AlertCircle,
  BookOpen,
  Bell,
  Zap,
  Target,
  Layers,
  Newspaper,
} from 'lucide-react';

/** Primary platform navigation (shown in Navbar and Policy Maker secondary row). */
export const PLATFORM_NAV_ITEMS = [
  { path: '/', label: 'Home', icon: Home },
  { path: '/overview', label: 'Overview', icon: BarChart3 },
  { path: '/supply-markets', label: 'Supply & Markets', icon: Globe },
  { path: '/partners-risk', label: 'Partners & Risk', icon: Users },
  { path: '/policy-intelligence', label: 'Policy & Intelligence', icon: FileText },
  { path: '/global-competitiveness', label: 'Global Competitiveness', icon: Award },
];

export const INTELLIGENCE_NAV_ITEMS = [
  // { path: '/global-resource-sentinel', label: 'Global Resource Sentinel', icon: Activity },
  // { path: '/geoeconomic-ai', label: 'Strategic Intelligence', icon: Brain },
  { path: '/event-tracker', label: 'Event Tracker', icon: Globe },
  { path: '/intelligence-briefing', label: 'Intelligence Briefing', icon: Newspaper },
  // { path: '/company-risk-intelligence', label: 'Company Risk Intelligence', icon: AlertCircle },
];

export const PREDICTION_NAV_ITEMS = [
  { path: '/predictive-alerts', label: 'Predictive Alerts', icon: Bell },
  { path: '/crisis-simulator', label: 'Crisis Simulator', icon: Zap },
];

export const METHODOLOGY_NAV_ITEM = {
  path: '/methodology',
  label: 'Methodology',
  icon: BookOpen,
};

/** Intelligence dropdown label (Navbar only). */
export const INTELLIGENCE_DROPDOWN = { label: 'Intelligence', icon: Layers };

export const PREDICTION_DROPDOWN = { label: 'Prediction & Simulation', icon: Target };

const MINIMAL_NAV_PATHS = new Set([
  '/',
  '/corporate',
  '/policy-maker',
  '/policy-makers',
  '/login',
  '/register',
]);
const EV_NAV_PATHS = new Set(['/ev-dashboard', '/ev_crisis_simulator']);

/** Paths that use the compact platform workspace navbar (logo + inline nav + account). */
const PLATFORM_WORKSPACE_EXTRA_PATHS = [
  '/search',
  '/account-settings',
  '/admin/users',
  '/data',
  '/critical-minerals-dashboard',
  '/trade-policy-tracker',
  '/critical-mineral-policies',
  '/partner-risk-table',
  '/data-upload',
  '/hs-codes',
  '/executive-summary',
  '/countries-situation-data',
];

export function isPlatformWorkspacePage(pathname) {
  if (MINIMAL_NAV_PATHS.has(pathname) || EV_NAV_PATHS.has(pathname)) {
    return false;
  }
  const primaryNavPaths = new Set([
    ...PLATFORM_NAV_ITEMS.map((item) => item.path),
    ...INTELLIGENCE_NAV_ITEMS.map((item) => item.path),
    ...PREDICTION_NAV_ITEMS.map((item) => item.path),
    METHODOLOGY_NAV_ITEM.path,
  ]);
  return primaryNavPaths.has(pathname) || PLATFORM_WORKSPACE_EXTRA_PATHS.includes(pathname);
}
